import {noContractMenu} from './constant';

import AlertWidget from '../../lib/Alert/Alert';
import Footer from '../../lib/Footer/Footer';
import FooterLegal from '../../lib/Footer/Footer-legal';
import HeaderNav from '../../lib/header/header';
import PopupModal from '../../lib/popupModel/popupModel';
import Sidebar from '../../lib/Sidebar/Sidebar';
import AccountConfiguration from '../accountConfiguration/accountConfiguration';
import Home from '../home/Home';
import Qualtrics from '../Qualtrics/Qualtrics';

import React, {Suspense} from 'react';
import {connect} from 'react-redux';

const LegalInformation = React.lazy(() =>
  import('../LegalInformation/LegalInformation')
);
const ServiceRequest = React.lazy(() =>
  import('../ServiceRequest/ServiceRequest')
);
const ServiceRequestDashboard = React.lazy(() =>
  import('../ServiceRequest/ServiceRequestDashboard/ServiceRequestDashboard')
);
const MyAccount = React.lazy(() => import('../MyAccount/MyAccount'));
const Contact = React.lazy(() => import('../contact/Contact'));
const PaymentSchedule = React.lazy(() =>
  import('../paymentSchedule/paymentSchedule')
);
const ContractDetails = React.lazy(() =>
  import('../contractDetails/ContractDetails')
);
const ContractDetailsOverview = React.lazy(() =>
  import('../contractDetails/ContractDetailsOverview/ContractDetailsOverview')
);
const RaiseComplaint = React.lazy(() =>
  import('../RaiseComplaint/RaiseComplaint')
);
const DocumentDownload = React.lazy(() =>
  import('../documentDownload/documentDownload')
);
const DownloadCenter = React.lazy(() =>
  import('../DownloadCenter/DownloadCenter')
);
const LeaseFAQ = React.lazy(() => import('../LeaseFAQ/LeaseFAQ'));

const NotificationWidget = React.lazy(() =>
  import('../NotificationWidget/NotificationWidget')
);

const RenderComponent = ({currentView, VIEWS}) => {
  return (
    <div className="main-content-landing">
      <Suspense fallback="Loading">
        <>{currentView && VIEWS[currentView]}</>
      </Suspense>
    </div>
  );
};

const VerifiedComponent = (props) => {
  const [visible, setVisible] = React.useState(false);

  const VIEWS = {
    home: <Home oktaAuth={props.oktaAuth} />,
    myAccount: <MyAccount />,
    contact: (
      <Contact
        noContract={
          props.contractNumber?.contractCounts <= 0 || props.contractNumberError
        }
      />
    ),
    serviceRequest: <ServiceRequest />,
    serviceRequestDashboard: <ServiceRequestDashboard />,
    legalInformation: <LegalInformation />,
    paymentSchedule: <PaymentSchedule />,
    contractDetails: <ContractDetails />,
    contractDetailsOverview: <ContractDetailsOverview />,
    raiseComplaint: <RaiseComplaint />,
    accountConfiguration: <AccountConfiguration />,
    download: <DocumentDownload />,
    downloadCenter: <DownloadCenter />,
    leaseFAQ: <LeaseFAQ />,
    notification: <NotificationWidget />,
  };

  return (
    <div
      id="logged-in-component"
      className={'LandingPageWrapper'}
      data-testid="LandingPageWrapper"
    >
      <Qualtrics />
      <div className="main-layout">
        <div className="app-header">
          <HeaderNav
            customerId={props.customerId}
            oktaAuth={props.oktaAuth}
            selectedMenu={props.currentView}
            setVisible={setVisible}
            organization={props.data.organization}
            setOrganization={props.setOrganization}
            onOrgChange={props.setNewOrg}
          />
          {props.data?.allContracts?.countryCode === 'in' && (
            <AlertWidget
              type="info"
              title=""
              content="LEASE_INFO_MSG"
              isClosable={false}
            />
          )}
        </div>

        {props.data.contractNumberError ||
        (props.data.contractNumber?.contractCounts <= 0 &&
          props.data.contractNumber?.pastContractsCounts <= 0) ? (
          noContractMenu.includes(props.currentView) ? (
            <RenderComponent currentView={props.currentView} VIEWS={VIEWS} />
          ) : null
        ) : (
          <RenderComponent currentView={props.currentView} VIEWS={VIEWS} />
        )}

        <div className={'sidebar-landing'}>
          <Sidebar
            selectedMenu={props.currentView}
            setVisible={setVisible}
            noContract={
              props.data.contractNumber?.contractCounts <= 0 ||
              props.data.contractNumberError?.isError
            }
            contractNumberError={props.data.contractNumberError?.isError}
          />
        </div>
        <div className="footer-landing">
          {props.data.contractNumberError?.isError ? null : (
            <Footer selectedMenu={props.currentView} />
          )}
        </div>
      </div>

      <div className="footer-legal-wrapper">
        {props.currentView === 'legalInformation' ? <FooterLegal /> : null}
      </div>

      <PopupModal
        id="signOutPopupModal"
        title={props.data.t('SIGNOUT')}
        description={props.data.t('SIGNOUT_CONFIRM_MSG')}
        action={props.data.t('SIGNOUT')}
        visible={visible}
        setVisible={setVisible}
        signoutPopup={props.oktaAuth}
      />
    </div>
  );
};

export const mapStateToProps = (state) => {
  return {
    currentView: state.appStates.viewList.at(-1),
  };
};
export default connect(mapStateToProps)(VerifiedComponent);
